module.exports = __webpack_public_path__ + "img/red.42401c9e.jpg";